import React from 'react';
import PropTypes from 'prop-types';

const ColorSwatch = ({ color, text }) => {
	if (color) {
		return (
			<div>
				<span
					className={`normalized-swatch normalized-swatch-${color.toLowerCase()} mr-3`}
				/>
				<span>{text}</span>
			</div>
		);
	}
	return <span>{text}</span>;
};

ColorSwatch.propTypes = {
	color: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired
};

export default ColorSwatch;
